export default {
      id: "returningTruckSatelliteHover-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#returningTruckSatelliteHover",
      toString: function () {
        return this.url;
      }
    }